import React from 'react'
import FormViewer from '../../components/FormViewer'
import LoaderButton from '../../components/LoaderButton'
import Responsive from '../../components/Responsive'
import { translate } from '../../utils/useful'
import CAHeader from '../../components/header/CAHeader'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'



class CAInquiryType extends React.Component {
    state = {

        headers2: [

            {
                type: 'ImageSelectInput', key: 'settings.type', col: 6, information: {
                    type: 'local',
                    items: [
                        { title: '{{lang}}ca.Survey', image: '/images/icons/satisfaction.png', value: 'survey', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                        { title: '{{lang}}ca.Quiz', image: '/images/icons/icons8-checklist-64.png', value: 'quiz', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                        // { title: 'Exams', image: '/images/icons/exam-icon.png', value: 'exams', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },

                    ],
                },
            },

        ],


        data: {},
    }

    componentDidMount() {
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                showSettings: false,
                create: true,
                // 'title': `${this.props.user?.info?.fullname}`,
                // 'info': translate('Create Applet') + " | " + translate('Choose Type'),
                topHeaderComponent: this.topHeaderComponent,
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.lastStage()

            })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    headerIdentityComponent = () => {
        return (
            <div className='' style={{ width: '90%' }} >
                <input onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.collectionName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} />
            </div>
        )
    }

    setName = (value) => {
        this.setState({ collectionName: value }, () => {
            this.setHeader("dummy", 1)
        })
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoading ? () => { } : () => this.nextStage()}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    isLoading={this.state.isLoading}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }
    nextStage = () => {
        let rawData = this.selectForm.getForm()
        let data = this.props.initData
        if (rawData) {
            console.log('data is ', data)
            if (!data.collectionInfo) {
                data.collectionInfo = {}
            }
            data.collectionInfo.mode = rawData.settings.type
            data.collectionInfo.collectionName = this.state.collectionName
            this.props.setData(data, () => {

                if(this.props.continue){
                this.props.continue(this.props.stageName)
                }else{
                    this.props.changeStage('access')  
                }
                // console.log('selected form0', data)
                // this.props.changeStage('access')
            })
        }
    }

    changeValue = (e) => {
        // console.log(e.value)
        this.props.changeValue(this.props.header.key, e.value, this.props.extra)
    }

    setData = (key, value) => {
        this.setState({ [key]: value })
    }
    render() {

        return (
            <div className=" w-100 h-100 position-relative flex-column" style={{}}>
                <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}> </div>
                </div>

                <div className=' w-100 py-3 scroll-no-scrollbar' style={{ height: 'calc(100% - 52px)' }}>
                    <Responsive width={this.props.width} media={{ xs: "12", md: '12' }}>
                        <div className='px-5  w-100 flexcc  flex-column'>
                            <div style={{ maxWidth: 650 }}>
                                {/* <div className='flexc'>
                                    <button onClick={() => this.props.lastStage()} className='flexc'>
                                        <div className='bg-dark-blue-1 br-50 ws-25 hs-25 flexcc rotate-180'>
                                            <img className='invert rtl-button' src="/assets/icons/useful/angle-right.svg" height={20} />
                                        </div>
                                    </button>

                                    <h2 className=" text-big mb-0 color-dark-blue-1 mx-2" >{translate('ca.Choose type')}</h2>
                                </div> */}

                                <div className='my-2'>
                                    <p className="mt-1 text-small color-dark-blue-1 " >{translate('ca.What type of test you are looking for?')}</p>
                                </div>

                                <div className='mt-3' >
                                    <FormViewer ref={el => this.selectForm = el} headers={this.state.headers2} initData={this.props.initData} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} />
                                </div>


                                {/* <div className='mt-1 mld-3 px-2'>
                                    <LoaderButton
                                        onClick={() => this.nextStage()}
                                        isLoading={this.state.isLoading}
                                        text={translate("ca.Continue")}
                                        icon={'/assets/icons/angle-right-white.svg'}
                                        backgroundImage='linear-gradient(90deg, hsla(197, 100%, 63%, 1) 0%, hsla(294, 100%, 55%, 1) 100%)'
                                        className={'button-interactive-1'}
                                        language={this.props.language}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}

export default CAInquiryType;